/**
 * Error codes for Support Portal – Save Clinic Appointment Type API
 * POST /api/secure/cc/support/clinic/clinic-appointment-type/save
 *
 * Maps backend error codes to user-friendly messages and suggested actions.
 */
export const SUPPORT_CLINIC_APPT_TYPE_SAVE_ERROR_CODES = {
  521: {
    message: 'Missing required information. Please ensure clinic, location, and all required fields are filled.',
    action: 'Check that Clinic, Location, Type, Mode, Items Type, Duration, and Price are set.',
  },
  4061: {
    message: 'You are not allowed to access this clinic.',
    action: 'Contact your admin if you should have access to this clinic.',
  },
  4041: {
    message: 'This appointment type was not found. It may have been deleted.',
    action: 'Refresh the list and try again. If editing, create a new service instead.',
  },
  3334: {
    message: 'Clinic event type not found. The service may have been removed or changed.',
    action: 'Refresh the page and try again.',
  },
  335: {
    message: 'This appointment type is missing a subscription plan and cannot be updated.',
    action: 'Contact support to fix the subscription plan for this service.',
  },
  413: {
    message: 'Only single appointment type is supported. Bundle type is not available.',
    action: 'Select "Single" for Items Type.',
  },
  4231: {
    message: 'Template type does not match. Please match the service type to the template.',
    action: 'Change the appointment type to match the template you selected.',
  },
  4233: {
    message: 'Template mode does not match. Please match online/offline to the template.',
    action: 'Change the mode (online/offline) to match the template.',
  },
  4234: {
    message: 'Template items type does not match. Please use the same items type as the template.',
    action: 'Change Items Type to match the template (use Single).',
  },
  50035: {
    message: 'Bundle creation is not supported yet.',
    action: 'Use "Single" for Items Type to create this service.',
  },
  50037: {
    message: 'Bundle update is not supported yet.',
    action: 'Use "Single" for Items Type or contact support.',
  },
  5201: {
    message: 'Unable to save this appointment type. The data may be invalid.',
    action: 'Check all fields (title, type, mode, duration, price) and try again.',
  },
  5401: {
    message: 'Failed to create or update the pricing plan.',
    action: 'Check price and currency, then try again. If it persists, contact support.',
  },
}

/**
 * Get user-friendly message and action for a support clinic appointment-type save error code.
 * @param {number} code - Backend error code
 * @returns {{ message: string, action?: string }}
 */
export function getSupportClinicApptTypeSaveError(code) {
  const entry = SUPPORT_CLINIC_APPT_TYPE_SAVE_ERROR_CODES[code]
  if (entry) {
    return { message: entry.message, action: entry.action }
  }
  return {
    message: 'Something went wrong while saving the service.',
    action: 'Please try again. If the problem continues, contact support.',
  }
}
